module.exports = __webpack_public_path__ + "img/vertical_4_2_5010.c0734598.png";